var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoop = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9E1E0",
    d: "M2.5 10.67q0-2.785 1.893-4.727T9 4h6q2.714 0 4.607 1.943Q21.5 7.885 21.5 10.669q0 2.514-1.592 4.386-1.593 1.874-4.018 2.22a.77.77 0 0 1-.622-.15.66.66 0 0 1-.268-.547.7.7 0 0 1 .265-.56q.266-.225.62-.298a4.8 4.8 0 0 0 2.963-1.754Q20 12.545 20 10.67q0-2.13-1.462-3.63-1.464-1.5-3.538-1.5H9q-2.075 0-3.537 1.5Q4 8.54 4 10.67q0 2.139 1.458 3.64 1.457 1.5 3.542 1.5h.771l-1.313-1.357a.73.73 0 0 1-.208-.528q0-.315.223-.544A.7.7 0 0 1 9 13.157a.7.7 0 0 1 .527.223l2.485 2.55a.9.9 0 0 1 .27.648.9.9 0 0 1-.27.65l-2.495 2.559a.7.7 0 0 1-.514.213.74.74 0 0 1-.53-.213.73.73 0 0 1-.228-.549.78.78 0 0 1 .228-.548l1.308-1.342H9q-2.714 0-4.607-1.947T2.5 10.669Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loop.b506a2c4.svg";